import { CommonSampleProcessResponse } from '@/api/resources/common/sample-process/sample-process.model'
import axios from 'axios'

class CommonSampleProcessService {
    async getCommonSampleProcess(): Promise<CommonSampleProcessResponse> {
        const response = await axios.get<CommonSampleProcessResponse>(`/sampleprocess/`)
        return response.data
    }
}

export const commonSampleProcessService = new CommonSampleProcessService()
